import { Dialog, DialogContentProps, DialogPortalProps, Spacer, isWeb } from 'tamagui'
import { X } from '@tamagui/lucide-icons'
import { useSafeArea } from '../../hooks'
import { Container } from '../container'
import { Button } from '../button'

export interface FullScreenDialogProps {
  open: boolean
  onOpenChange: (value) => void
  children: React.ReactNode
  contentProps?: DialogContentProps
  portalProps?: DialogPortalProps
  title?: string
  closeOnOverlayPress?: boolean
  BeforeTitleComponent?: React.ReactNode
}

export const FullScreenDialog = ({
  open,
  onOpenChange,
  contentProps,
  portalProps,
  title,
  closeOnOverlayPress = true,
  children,
  BeforeTitleComponent,
}: FullScreenDialogProps) => {
  const { bottom } = useSafeArea()

  const insets = isWeb ? {} : { pb: bottom + 16 }

  return (
    <Dialog modal open={open} onOpenChange={closeOnOverlayPress ? onOpenChange : () => {}}>
      <Dialog.Portal zIndex="$2" h="100%" p="$4" $gtMd={{ p: '$5' }} {...insets} {...portalProps}>
        <Dialog.Overlay
          key="overlay"
          animation="quick"
          bg="$backdrop"
          opacity={1}
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
        />

        <Dialog.Content
          width="100%"
          maxWidth={1200}
          height="100%"
          borderRadius="$3"
          key="content"
          p="$0"
          m="$0"
          animation={[
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          y={0}
          opacity={1}
          enterStyle={{ opacity: 0, y: 100 }}
          exitStyle={{ opacity: 0, y: 100 }}
          {...contentProps}
        >
          {title && (
            <Container
              fd="row"
              ai="center"
              btlr="$3"
              btrr="$3"
              bg="$black"
              w="100%"
              jc="center"
              py="$2"
              gutter
              zIndex="$4"
              size="xl"
            >
              {/* @ts-ignore spacer style props do exist. Bug in Tamagui */}
              {BeforeTitleComponent ? BeforeTitleComponent : <Spacer w={32} mr="auto" />}
              <Dialog.Title mx="auto" color="$white" textAlign="center" size="$6" fow="600">
                {title}
              </Dialog.Title>
              <Button p="$0" onPress={() => onOpenChange(false)} plain ml="auto">
                <X size={32} color="white" />
              </Button>
            </Container>
          )}
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  )
}
